// Helper function to highlight the search term in the text.
export function highlightSearchText(text, query) {
  if (!query?.trim()) return text;

  // Helper function to escape RegExp special characters
  function escapeRegExp(string) {
    return string.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  }

  const escapedQuery = escapeRegExp(query);

  const regex = new RegExp(`(${escapedQuery})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <span key={index} className="font-bold">
        {part}
      </span>
    ) : (
      part
    )
  );
}
